import history from '@ane/core/lib/CreateHistory';
import { combineEpics } from 'redux-observable';
import { provideDataSourceListEpics } from './DataSourceListEpic';
import dataSourceDeleteEpic from './DataSourceDeleteEpic';
import dataSourceCloneEpic from './DataSourceCloneEpic';
const dataSourceListEpic = provideDataSourceListEpics(history);
export const rootEpic = combineEpics(dataSourceListEpic, dataSourceCloneEpic, dataSourceDeleteEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
